import React, { Component } from 'react';
import {Card, CardTitle, CardText} from 'material-ui/Card';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import CerseActions from '../../actions/CerseActions';
import CerseStore from '../../stores/CerseStore';

class Page extends Component {
  state = {
    content: CerseStore.getState().formsContent,
    methods: CerseStore.getState().methods,
  };

  assign(assign) {
    let newContent = Object.assign(this.state.content, assign);

    this.setState({ content: newContent });

    CerseActions.saveFormsContent(newContent);
  }

  render() {
    let methods = this.state.methods.map(j => { return {
      value: j.value,
      label: j.label + ' - ' + j.description
    }});
    return (
      <Card>
        <CardTitle title="Identify the Research Units" subtitle="2/5" />
        <CardText>
          <p>Select the research methods intended for each individual study. Note that the choice of a particular methodology affects the data collection and data analysis techniques. Use the fields below to filter the supporting instruments according to their characteristics (i.e. objectives, covered phases, maturity level and relations with other research units).</p>

          <Select name="methods" placeholder="Select the research methods(s)" multi
            options={methods}
            value={this.state.content.methods}
            onChange={(value) => { this.assign({ methods: value }); }}
          />
        </CardText>
      </Card>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/Step2.js